import React from 'react'
// import img1 from '../../assets/banner/bannerDisplay/d1.webp'
// // import img2 from '../assets/banner/bannerDisplay/d2.webp'
// // import img3 from '../assets/banner/bannerDisplay/d3.webp'

function BannerDisplay() {
  return (
    <div>
        <div>
            {/* <img src={img1} alt='banner-screen' /> */}
        </div>
        <div>
            <div>
                {/* <img src={img2} alt='banner-screen'/> */}
            </div>
            <div>
                {/* <img src={img3} alt='banner-screen'/> */}
            </div>
        </div>
    </div>
  )
}

export default BannerDisplay